import React, { useState, useEffect } from "react";
import "./Homepage.css";
import ImageSlider from "../components/ImageSlider";
import OurObjectives from "./OurObjectives";
import OurGallery from "./OurGallery";
import RegisterForm from './RegisterForm';
import MemberCard from './MemberCard';
import { FaWhatsapp, FaPhoneAlt, FaLanguage } from "react-icons/fa";
import Contact from './Contact';
import Pop from "./Pop";
import Video from "./Video";
import Gal from "./Gal";
import QuoteMarquee from "./QuoteMarquee";
import Payments from "./Payments";
function HomePage() {
  const [isTamil, setIsTamil] = useState(false);
  const [showScroll, setShowScroll] = useState(false);
  const [showFullText, setShowFullText] = useState(false);

  const englishContent = `Tamilmanamalai charitable Trust is a social welfare organization committed to supporting underprivileged communities through various charitable initiatives. The foundation focuses on improving the lives of the poor, especially by offering marriage assistance to both men and women from economically weaker backgrounds. By providing financial support and essential items for marriage, the foundation helps families conduct weddings with dignity, reducing the financial burden they face. The foundation also extends care and support to destitute elderly people, ensuring they are not neglected in their later years. In addition, it actively supports students who have lost their parents, helping them with education, cultural activities, and social development opportunities. These efforts aim to empower orphaned children and give them hope for a better future. To promote economic independence and preserve traditional skills, the Tamilmanamalai Foundation distributes handicraft tools and instruments to individuals seeking self-employment. This initiative benefits both men and women, encouraging them to take up small-scale craftsmanship, thereby boosting local economic and social development. Among its most impactful services, the foundation prioritizes accessible healthcare for all. It regularly conducts free medical camps in rural and underdeveloped areas, offering health checkups, diagnosis, and treatment for common illnesses. These camps provide not only basic medicines but also immediate care completely free of cost to those who cannot afford medical services.
  `; // shortened for clarity

  const tamilContent = `தமிழ்மணமலை அறக்கட்டளை என்பது பல்வேறு தொண்டு முயற்சிகள் மூலம் சமூகத்தில் பின்தங்கியவர்களுக்கு ஆதரிப்பதற்கு உறுதிபூண்டுள்ள ஒரு சமூக நல அமைப்பாகும். இந்த அறக்கட்டளை ஏழைகளின் வாழ்க்கையை மேம்படுத்துவதில் கவனம் செலுத்துகிறது, குறிப்பாக பொருளாதார ரீதியாக பலவீனமான பின்னணியைச் சேர்ந்த ஆண்கள் மற்றும் பெண்கள் இருவருக்கும் திருமண உதவி வழங்குவதன் மூலம். திருமணத்திற்கு நிதி உதவி மற்றும் அத்தியாவசிய பொருட்களை வழங்குவதன் மூலம், கண்ணியமாக குடும்பம் நடத்தவும், அவர்கள் எதிர்கொள்ளும் நிதிச் சுமையைக் குறைக்கவும் அறக்கட்டளை உதவுகிறது. ஆதரவற்ற முதியவர்களுக்கு இந்த அறக்கட்டளை மருத்துவம், உணவு, உடை, பராமரிப்பு மற்றும் ஆதரவை வழங்குகிறது, கூடுதலாக, பெற்றோரை இழந்த மற்றும் ஏழை எளிய மாணவர்களுக்கு கல்வி பயில உதவி செய்தல். இந்த முயற்சிகள் அனாதை, ஏழை எளிய குழந்தைகளுக்கு வாழ்வாதாரத்தை அளிப்பதையும் அவர்களுக்கு சிறந்த எதிர்காலத்திற்கான நம்பிக்கையை அளிப்பதையும் நோக்கமாகக் கொண்டுள்ளது. பொருளாதார சுதந்திரத்தை ஊக்குவிக்கவும் பாரம்பரிய திறன்களைப் பாதுகாக்கவும், தமிழ்மணமலை அறக்கட்டளை சுயதொழில் தேடும் தனிநபர்களுக்கு கைவினைக் கருவிகள் மற்றும் கருவிகளை விநியோகிக்கிறது. இந்த முயற்சி ஆண்கள் மற்றும் பெண்கள் இருவருக்கும் பயனளிக்கிறது, அவர்கள் சிறிய அளவிலான கைவினைத்திறனை மேற்கொள்ள ஊக்குவிக்கிறது, இதன் மூலம் உள்ளூர் பொருளாதார மற்றும் சமூக வளர்ச்சியை அதிகரிக்கிறது. அறக்கட்டளை அனைவரும் அணுகக்கூடிய சுகாதாரப் பராமரிப்பை முன்னுரிமைப்படுத்துகிறது. இது கிராமப்புற மற்றும் பின்தங்கிய பகுதிகளில் இலவச மருத்துவ முகாம்களை தொடர்ந்து நடத்தி, சுகாதார பரிசோதனைகள், நோயறிதல் மற்றும் பொதுவான நோய்களுக்கான சிகிச்சையை வழங்குகிறது. இந்த முகாம்கள் மூலம் மருந்து,மருத்துவ உபகரங்கள் வாங்க முடியாதவர்களுக்கு அடிப்படை மருந்துகளை மட்டுமல்ல, சிகிச்சையையும் முற்றிலும் இலவசமாக வழங்குகிறது.
  `; // shortened for clarity

  const english = {
    name: "Mr.T.Nanthakumar, BE., (Mech)",
    role: "Founder & President",
    description:
      "The visionary behind the Tamil Manamalai Charitable Trust. He leads with dedication and hands-on involvement, guiding the organization's mission to uplift.",
    contactLabel: "Contact:",
  };

  const tamil = {
    name: "மிஸ்டர்.த.நந்தகுமார், BE., (Mech)",
    role: "அறக்கட்டளை தலைவர்",
    description: "",
    contactLabel: "தொடர்பு:",
  };

  const arumugam = {
    en: {
      name: "Mr.P.Arumugam, BBA.,",
      role: "Secretary",
      description:
        "Originator of the organization who also plays a hands-on role in overseeing operations and strategy.",
      contact: "Contact:",
    },
    ta: {
      name: "மிஸ்டர்.பெ.ஆறுமுகம்,BBA.,",
      role: "அறக்கட்டளை செயலாளர்",
      description: "",
      contact: "தொடர்பு:",
    },
  };

  const content = isTamil ? tamil : english;
  const arumugamContent = isTamil ? arumugam.ta : arumugam.en;

  const maxLength = 800; // max chars before showing 'More'

  const contentToShow = isTamil ? tamilContent : englishContent;

  const displayedText = showFullText
    ? contentToShow
    : contentToShow.length > maxLength
    ? contentToShow.slice(0, maxLength) + "..."
    : contentToShow;

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScroll && window.pageYOffset > 100) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 100) {
        setShowScroll(false);
      }
    };
    window.addEventListener("scroll", checkScrollTop);
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, [showScroll]);
const [registeredMember, setRegisteredMember] = useState(null);

const handleRegister = (formData) => {
  setRegisteredMember(formData);
};

  return (
    <div className="homepage-wrapper">
      <div className="homepage">
        {/* HOME SECTION */}
        
        <div id="home">
        

<QuoteMarquee />
          <ImageSlider />
          

          <Pop />
        </div>

        {/* ABOUT SECTION */}
       <section id="about" className="about-section">
  {/* About Description */}
  <div className="about-card">
    <div className="about-header">
      <h2>{isTamil ? "எங்களை பற்றி" : "About Us"}</h2>
      <button
        onClick={() => setIsTamil(!isTamil)}
        className="translate-btn"
      >
        <FaLanguage style={{ marginRight: "8px" }} />
        {isTamil ? "Translate to English" : "Translate to தமிழ்"}
      </button>
    </div>

    <p className="about-text">{displayedText}</p>

    {contentToShow.length > maxLength && (
      <button
        onClick={() => setShowFullText(!showFullText)}
        className="more-btn"
      >
        {showFullText ? (isTamil ? "குறைந்தது" : "Show Less") : isTamil ? "மேலும்" : "More"}
      </button>
    )}
  </div>

  {/* Owners Section */}
  <div className="owners-container">
    {[content, arumugamContent].map((owner, index) => (
      <div key={index} className="owner-card">
        <img
          src={index === 0 ? "/new_prof.jpeg" : "new.jpg"}
          alt={owner.name}
          className="owner-image"
        />
        <div className="owner-info">
          <h3>{owner.name}</h3>
          <b>{owner.role}</b>
          <p>{owner.description}</p>
          <p className="owner-contact">{owner.contactLabel || owner.contact}</p>
          <div className="contact-icons">
            <a
              href={`https://wa.me/${index === 0 ? "919976992375" : "919840716807"}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp className="icon whatsapp" />
            </a>
            <a href={`tel:+${index === 0 ? "919976992375" : "919840716807"}`}>
              <FaPhoneAlt className="icon phone" />
            </a>
          </div>
        </div>
      </div>
    ))}
  </div>
</section>


        {/* OBJECTIVES SECTION */}
        <div id="articles">
          <OurObjectives />
        </div>
  <section id="certificates" className="certificates-section">
  <div className="container">
    {/* Title Wrapper */}
    <div className="title-wrapper">
      <h2 className="section-title">12AB Certificate</h2>
      <div className="title-underline"></div>
      {/* Description moved here with justify alignment */}
      <p className="section-description">
        Official Income Tax Department registration validating our non-profit welfare activities. 
        This certification ensures that our organization complies with official regulations 
        and remains dedicated to transparent social welfare operations. Official certifications 
        and compliance documents are maintained here for public verification and organizational 
        integrity.
      </p>
    </div>

    <div className="certificate-grid">
      {/* 12AB Certificate Card */}
      <div className="certificate-card">
        <div className="card-pdf-wrapper">
          <iframe
            src="/permission.pdf#toolbar=0"
            title="12AB Certificate PDF"
            className="pdf-viewer"
          ></iframe>
        </div>
        <div className="card-content">
          {/* Only the Download Button remains here */}
          <div className="button-container">
            <a
              href="/permission.pdf"
              download="12AB_Certificate.pdf"
              className="download-btn"
            >
              📥 Download Certificate
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <style jsx>{`
    .certificates-section {
      padding: 80px 20px;
      background-color: #ffffff;
      width: 100%;
    }

    .container {
      max-width: 1200px;
      margin: 0 auto;
    }

    .title-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      width: 100%;
      margin-bottom: 40px;
    }

    .section-title {
      font-size: 2.2rem;
      color: #1a1a1a;
      margin: 0;
      font-weight: 700;
      text-transform: uppercase;
      width: 100%;
    }

    .title-underline {
      width: 100px;
      height: 4px;
      background: linear-gradient(to right, #ff9933, #d4d4d4, #138808);
      margin: 12px auto;
      border-radius: 2px;
    }

    .section-description {
      color: #555;
      font-size: 1.05rem;
      margin-top: 15px;
      max-width: 800px;
      line-height: 1.8;
      /* Justify content requested */
      text-align: justify;
    }

    .certificate-grid {
      display: flex;
      justify-content: center;
      width: 100%;
    }

    .certificate-card {
      background: #fff;
      border-radius: 15px;
      overflow: hidden;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
      border: 1px solid #f0f0f0;
      display: flex;
      flex-direction: column;
      transition: transform 0.3s ease;
      width: 100%;
      max-width: 500px;
    }

    .certificate-card:hover {
      transform: translateY(-5px);
    }

    .card-pdf-wrapper {
      height: 500px;
      background: #f8f9fa;
      position: relative;
    }

    .pdf-viewer {
      width: 100%;
      height: 100%;
      border: none;
    }

    .card-content {
      padding: 30px;
      text-align: center;
    }

    .button-container {
      display: flex;
      justify-content: center;
      width: 100%;
    }

    .download-btn {
      display: inline-block;
      padding: 14px 32px;
      background-color: #28a745;
      color: white;
      text-decoration: none;
      border-radius: 8px;
      font-size: 1rem;
      font-weight: bold;
      transition: all 0.3s ease;
      border: none;
      cursor: pointer;
    }

    .download-btn:hover {
      background-color: #218838;
      box-shadow: 0 5px 15px rgba(40, 167, 69, 0.3);
      transform: scale(1.02);
    }

    @media (max-width: 768px) {
      .section-title {
        font-size: 1.7rem;
      }
      .section-description {
        text-align: left; /* Better readability on small screens */
        padding: 0 10px;
      }
      .card-pdf-wrapper {
        height: 350px;
      }
      .certificates-section {
        padding: 50px 15px;
      }
    }
  `}</style>
</section>
        {/* REGISTRATION SECTION */}
        <section id="registration" className="registration-section">
          <div className="container">
            {!registeredMember ? (
              <RegisterForm
                onRegister={handleRegister}
                isTamil={isTamil}
                toggleLanguage={() => setIsTamil(!isTamil)}
              />
            ) : (
              <MemberCard member={registeredMember} isTamil={isTamil} />
            )}
          </div>
        </section>

        {/* GALLERY SECTION */}
        <div id="gallery">
          <OurGallery isTamil={isTamil} />
        </div>
          <div id="gal">
          <Gal />
        </div>
      </div>
      <section id="video">
        <Video />
      </section>
      {/* CONTACT SECTION */}
      <div id="contact">
        <Contact />
      </div>

      {/* FOOTER */}
    <footer className="site-footer">
  <div className="translate-top">
    <button
      onClick={() => setIsTamil(!isTamil)}
      style={{
        marginTop: '10px',
        marginBottom: '20px',
        backgroundColor: '#4CAF50',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer',
        fontSize: '14px'
      }}
    >
      <FaLanguage />
      {isTamil ? "Translate to English" : "தமிழில் மொழிபெயர்"}
    </button>
  </div>

  <div className="footer-container">
    <div className="footer-section">
      <h4>{isTamil ? "எங்களை பற்றி" : "About Us"}</h4>
      <p>
        {isTamil
          ? "தமிழ்மணமலை அறக்கட்டளை சமூக நலனிற்காக செயல்படும் ஒரு அமைப்பாகும். நமது நோக்கம் ஏழை எளிய மக்களுக்கு திருமண உதவி செய்தல்,ஆதரவற்ற முதியோர்க்கு உதவுதல் மற்றும் பெற்றோர்களை இழந்த மாணவர்களுக்கு கல்வி ,பண்பாடு மற்றும் சமூக சேவைகளை மேம்படுத்தல்."
          : "Tamilmanamalai Foundation is an organization working for social welfare. Our mission is to provide marriage assistance to the poor and needy, help the destitute elderly and improve education, culture and social services for students who have lost their parents."}
      </p>
    </div>

    {/* புதிதாக சேர்க்கப்பட்ட பகுதி: Policies & Certificates */}
    <div className="footer-section">
      <h4>{isTamil ? "கொள்கைகள் மற்றும் சான்றிதழ்கள்" : "Policies & Certificates"}</h4>
      <ul style={{ listStyle: 'none', padding: 0, marginTop: '10px' }}>
        <li style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ color: '#a5d6a7' }}>▶</span>
          <a href="/terms" style={{ color: 'white', textDecoration: 'none' }}>
            {isTamil ? "பயன்பாட்டு விதிகள்" : "Terms Of Use"}
          </a>
        </li>
        <li style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ color: '#a5d6a7' }}>▶</span>
          <a href="/privacy" style={{ color: 'white', textDecoration: 'none' }}>
            {isTamil ? "தனியுரிமைக் கொள்கை" : "Privacy Policy"}
          </a>
        </li>
        <li style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ color: '#a5d6a7' }}>▶</span>
          <a href="/refund" style={{ color: 'white', textDecoration: 'none' }}>
            {isTamil ? "பணம் திரும்பப் பெறும் கொள்கை" : "Refund Policy"}
          </a>
        </li>
       {/* 80G Certificate with Alert */}


{/* 12A Certificate opening PDF */}
<li style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '8px' }}>
  <span style={{ color: '#a5d6a7' }}>▶</span>
  <a 
    href="/permission.pdf" 
    target="_blank" 
    rel="noreferrer" 
    style={{ color: 'white', textDecoration: 'none' }}
  >
    {isTamil ? "12AB சான்றிதழ்" : "12A Certificate"}
  </a>
</li>
      </ul>
    </div>

    <div className="footer-section">
      <h4>{isTamil ? "தொடர்பு" : "Contact"}</h4>
      <p>Email: <a href="mailto:tamilmanamalaitrust@gmail.com" style={{ color: 'white' }}>tamilmanamalaitrust@gmail.com</a></p>
      <p>Phone: <a href="tel:+919976227686" style={{ color: 'white' }}>+91 9976227686</a></p>
      <p>
        {isTamil
          ? `முகவரி: 68, ரோஜா காம்ப்ளெக்ஸ், சந்நதி தெரு, ஜெயங்கொண்டம், அரியலூர், பின் - 621802.`
          : `Location: 68, ROJA COMPLEX, SANNATHI STREET, JAYANKONDAM, ARIYALUR, PINCODE - 621802.`}
      </p>
    </div>
  </div>

 <div
  className="footer-bottom"
  style={{
    backgroundColor: "#0f3d2e",
    color: "#e0f2e9",
    padding: "40px 20px", // Increased padding for a better look
    textAlign: "center",
    borderTop: "2px solid #2e7d32",
    fontSize: "16px", // Slightly larger base font
    lineHeight: "1.8"
  }}
>
  <div className="footer-social-play">
    {/* Large Social Icons */}
    <div className="social-icons" style={{ display: 'flex', gap: '30px', justifyContent: 'center', marginBottom: '25px' }}>
      <a href="https://www.youtube.com/watch?v=PX_sKZam5w4" target="_blank" rel="noreferrer" style={{ color: 'red', fontSize: '40px' }}>
        <i className="fab fa-youtube"></i>
      </a>
      <a href="https://www.instagram.com/tamilmanamalai?utm_source=qr" target="_blank" rel="noreferrer" style={{ color: '#C13584', fontSize: '40px' }}>
        <i className="fab fa-instagram"></i>
      </a>
      <a href="https://www.facebook.com/people/%E0%AE%A4%E0%AE%AE%E0%AE%BF%E0%AE%B4%E0%AF%8D%E0%AE%AE%E0%AE%A3%E0%AE%AE%E0%AE%BE%E0%AE%B2%E0%AF%88-%E0%AE%A4%E0%AF%8A%E0%AE%A3%E0%AF%8D%E0%AE%9F%E0%AF%81-%E0%AE%85%E0%AE%B1%E0%AE%95%E0%AF%8D%E0%AE%95%E0%AE%9F%E0%AF%8D%E0%AE%9F%E0%AE%B3%E0%AF%88/pfbid02jM57ZswWjD9s2zTKejeH8ufYgVJ9MM1vDYAn958KUPSZs3QDNkb6yqc42oUKewt9l/?rdid=g6F3q1V8BffqYbkq&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1BioXGW3Tw%2F" target="_blank" rel="noreferrer" style={{ color: '#1877f2', fontSize: '40px' }}>
        <i className="fab fa-facebook"></i>
      </a>
      <a href="https://x.com/tamilmanam8624" target="_blank" rel="noreferrer" style={{ color: '#ffffff', fontSize: '40px' }}>
        <i className="fab fa-x-twitter"></i> {/* Updated to X logo icon if available */}
      </a>
    </div>

    {/* Play Store Badge */}
    <div className="playstore-badge" style={{ marginBottom: '30px', display: 'flex', justifyContent: 'center' }}>
      <a href="https://play.google.com/store/apps/details?id=com.app.tamilmanamalai" target="_blank" rel="noreferrer">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
          alt="Get it on Google Play"
          style={{ height: '60px' }} // Increased height
        />
      </a>
    </div>
  </div>

  {/* Updated Copyright Section with Integrated Social Links */}
  <div style={{ marginTop: '20px', borderTop: '1px solid rgba(165, 214, 167, 0.2)', paddingTop: '20px' }}>
    <p style={{ margin: 0, fontWeight: '500' }}>
      © 2026 {isTamil ? "தமிழ்மணமலை அறக்கட்டளை" : "Tamilmanamalai Charitable Trust"}. 
      {isTamil ? " அனைத்து உரிமைகளும் பாதுகாக்கப்படுகின்றன." : " All rights reserved."}
    </p>
    
    {/* Social Text Links in Copyright Area */}
   

    <p style={{ margin: "15px 0 0", fontWeight: "bold", color: "#a5d6a7", letterSpacing: '1px' }}>
      {isTamil ? "வடிவமைத்தவர் மற்றும் உருவாக்கியவர்: " : "DESIGNED AND CREATED BY: "}
      <span style={{ color: "#ffffff" }}>ARULSELVAN K</span>
    </p>
  </div>
</div>
</footer>
</div>
  );
}

export default HomePage;
